import { LANDINGS_STORE_NAME } from 'modules/landings-info';
import { State } from 'store/types';
import { useStoreon } from 'storeon/react';
import { KitchenPricePdpCategoryStructure } from '../category-card-section-types';
import {
  KITCHEN_PRICE_PDP_CATALOG_CATEGORY_LIST,
  KITCHEN_PRICE_PDP_MODULAR_CATEGORY_LIST,
} from '../category-card-section-constants';

/**
 * Возвращает данные для категорий товаров
 */
export const useCategoriesListSelector = (): KitchenPricePdpCategoryStructure[] => {
  const {
    landings: { landingsList },
  } = useStoreon<State>(LANDINGS_STORE_NAME);

  return landingsList?.find(landing => landing.landingName === 'kitchen-collections')
    ? KITCHEN_PRICE_PDP_MODULAR_CATEGORY_LIST
    : KITCHEN_PRICE_PDP_CATALOG_CATEGORY_LIST;
};
